
// import React from 'react';
// import { Link } from "react-router-dom";
// import './App.css'; // Import the CSS file
// import linkedin from './Images/ic-linkedin.webp';
// import facebook from './Images/ic-facebook.webp';
// import twitter from './Images/ic-twitter.webp';
// import Instagram from './Images/ic-instagram.webp';
// import YT from './Images/ic-youtube.webp';
// import pinterest from './Images/ic-pintrest.webp';
// import reddit from './Images/ic-reddit.webp';
// import logo1 from './Images/BestowalFooter.webp'; // Adjust the path as necessary
// import './App.css'; // Import the CSS file
// const Footer = () => {
//   // Function to handle scroll-to-top
//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth'
//     });
//   };

//   return (
//     <footer className="container-fluid footer">
//       <div className="container">
//         <div className="row">
//           <div className="col-md-5 footer-section">
//             <img src={logo1} alt="Bestowal Footer Logo" title="Bestowal Logo" className="footer-logo mb-3" />
//             <p>Bestowal Systems and Services is a company which is involved in product<br /> development and consultancy services for various technologies.</p>
//             <h6 className="address">
//               <b>Office Address:</b> 2nd Floor, Office No.21, Wadhwani Plaza, Next to Vishal Theatre, Pimpri 411018.
//             </h6>
//             <tel className='contactno'>+91 94055 30011</tel>
//           </div>
//           <div className="col-md-7 footer-section1">
//             <div className="row footerrow">
//               <div className="col-md-3">
//                 <h4>Services</h4>
//                 <ul className="list-unstyled">
//                   <li><Link className="nav-link" to="/supplychainmanagement" onClick={scrollToTop}>
//                     SAP Services
//                   </Link></li>
//                   <li><Link className="nav-link" to="/Mobiledevelopment" onClick={scrollToTop}>
//                     Mobile Services
//                   </Link></li>

//                   <li><Link className="nav-link" to="/industrylanding" onClick={scrollToTop}>
//                     Industries
//                   </Link></li>
//                   <li><Link className="nav-link" to="/products" onClick={scrollToTop}>
//                     Products
//                   </Link></li>
//                   {/* <li><Link className="nav-link" to="/digital" onClick={scrollToTop}>
//                       Digital Marketing
//                     </Link></li> */}
//                 </ul>
//               </div>
//               <div className="col-md-2">
//                 <h4>Company</h4>
//                 <ul className="list-unstyled">
//                   <li><Link className="nav-link" to="/careerlanding" onClick={scrollToTop}>
//                     Careers
//                   </Link></li>
//                   {/* <li><a href="#policy">Policy</a></li> */}
//                   <li><Link className="nav-link" to="/about" onClick={scrollToTop}>
//                     About US
//                   </Link></li>
//                 </ul>
//               </div>
//               <div className="col-md-2">
//                 <h4>Support</h4>
//                 <ul className="list-unstyled">
//                   <li><Link className='nav-link' to="/contact-us" onClick={scrollToTop}>Contact us</Link></li>
//                   <li><Link className='nav-link' to="/blogs" onClick={scrollToTop}>Blogs</Link></li>
//                 </ul>
//               </div>
//               <div className="col-md-5">
//                 <h4>Contact</h4>
//                 <ul className="list-unstyled">
//                   <li className='hr'><a href="mailto:info@bestowal.com">HR: <span>hr@bestowalsystems.com</span></a></li>
//                   <li className='carrier'><a href="mailto:support@bestowal.com">Careers: <span>careers@bestowalsystems.com</span></a></li>
//                   <li className='business'><a href="mailto:sales@bestowal.com">Business: <span>contact@bestowalsystems.com</span></a></li>
//                 </ul>
//               </div>
//             </div>

//             <div className="row">
//               <div className="col">
//                 <h5>Social</h5>
//                 <div className="social-icons mr-10">

//                   <a href="https://www.linkedin.com/company/bestowal-systems-and-services-private-limited/" className="linkedin" target="_blank" rel="noopener noreferrer">
//                     <img src={linkedin} className='social-icon' alt='Bestowal_linkedin_Account' title='Bestowal_Linkedin' />
//                   </a>
//                   <a href="https://www.facebook.com/bestowalsystems" className="pinterest" target="_blank" rel="noopener noreferrer">
//                     <img src={facebook} className='social-icon' alt='Bestowal_facebook_Account' title='Bestowal_Facebook' />
//                   </a>
//                   <a href="https://x.com/bestowalsystems?t=tUhwfo5zEXhU5SON5Ice2g&s=09" className="facebook" target="_blank" rel="noopener noreferrer">
//                     <img src={twitter} className='social-icon' alt='Bestowal_X_Account' title='Bestowal_X' />
//                   </a>
//                   <a href="https://www.instagram.com/bestowalsystems?igsh=MWY1ODV5Mmc4am02aA==" className="twitter" target="_blank" rel="noopener noreferrer">
//                     <img src={Instagram} className='social-icon' alt='Bestowal_Instagram_Account' title='Bestowal_Instagram' />
//                   </a>
//                   <a href="https://youtube.com/@bestowalsystems?si=JwmKOLGIGSFmTbk5" className="instagram" target="_blank" rel="noopener noreferrer">
//                     <img src={YT} className='social-icon' alt='Bestowal_YouTube_Account' title='Bestowal_Youtube' />
//                   </a>
//                   <a href="https://pin.it/5aaQo7dzK" className="youtube" target="_blank" rel="noopener noreferrer">
//                     <img src={pinterest} className='social-icon' alt='Bestowal_pinterest_Account' title='Bestowal_Pinterest' />
//                   </a>
//                   <a href="https://www.reddit.com/user/bestowalsystems/" className="reddit" target="_blank" rel="noopener noreferrer">
//                     <img src={reddit} className='social-icon' alt='Bestowal_reddit_Account' title='Bestowal_reddit' />
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <hr />
//       <div className="container-fluid">
//         <div className="row footer-bottom">
//           <div className="col text-center">
//             <p>
//               Copyright © 2025 Bestowal System & Services.
//               <a href="https://www.bestowalsystems.com"> www.bestowalsystems.com </a> | All Rights Reserved.
//             </p>
//           </div>
//           <div className="col text-right">

//             <button className="btn btn-primary scroll-top-btn" onClick={scrollToTop} alt="toggle_up_Arrow" title="toggle UP">
//               <span className="material-symbols-outlined" style={{ display: 'inline-block', transform: 'rotate(-90deg)', margin: '0px' }} >
//                 east
//               </span>
//             </button>

//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import React, { useState, useEffect } from "react";
import {
  FaLinkedin,
  FaInstagram,
  FaYoutube,
  FaTwitter,
  FaFacebook,
  FaChevronUp,
} from "react-icons/fa";
import logo from '../src/Images/BestowalFooter.webp'; // replace with your logo
import { NavLink } from "react-router-dom"; // ✅ for internal navigation
import { motion } from "framer-motion";
import { policyAPI } from "./services/api";
import { openCookiePreferences } from "./components/CookieConsent";

// Fallback legal links shown if the API is unreachable, so the footer always
// has the essential pages even before/without a successful fetch.
const FALLBACK_LEGAL_LINKS = [
  { title: "Privacy Policy", slug: "privacy-policy" },
  { title: "Cookie Policy", slug: "cookie-policy" },
  { title: "Terms of Use", slug: "terms-of-use" },
];

// Quick Links mirror the navbar's top-level tabs (same order, same landing routes).
const QUICK_LINKS = [
  { name: "Services", path: "/bestoservice" },
  { name: "Industries", path: "/industry" },
  { name: "AI Solutions", path: "/AI-Machine-Learning-Solution" },
  { name: "Products", path: "/products" },
  { name: "Insights", path: "/blogs" },
  { name: "About Us", path: "/about" },
  { name: "Careers", path: "/careerlanding" },
];

const Footer = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  // Legal links are CMS-driven: every active policy (Admin → Legal Pages) shows
  // up here automatically, so adding e.g. a "Disclaimer" needs no code change.
  const [legalLinks, setLegalLinks] = useState(FALLBACK_LEGAL_LINKS);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    let active = true;
    policyAPI
      .getAll()
      .then((res) => {
        if (active && Array.isArray(res.data) && res.data.length) {
          // Show the three core pages first (in the conventional order), then
          // any additional CMS pages (e.g. Disclaimer) alphabetically.
          const order = ["privacy-policy", "cookie-policy", "terms-of-use"];
          const rank = (s) => (order.indexOf(s) === -1 ? 99 : order.indexOf(s));
          const sorted = [...res.data].sort(
            (a, b) => rank(a.slug) - rank(b.slug) || a.title.localeCompare(b.title)
          );
          setLegalLinks(sorted.map((p) => ({ title: p.title, slug: p.slug })));
        }
      })
      .catch(() => {
        /* keep the fallback links on failure */
      });
    return () => {
      active = false;
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Subtle, fast footer entry: columns fade up in sequence once it scrolls into view.
  const footerStagger = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.1 } },
  };
  const footerColItem = {
    hidden: { opacity: 0, y: 24 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
  };

  return (
    <>
      {/* <footer className="bg-[#05314d] text-white">
        <div className="w-[90%] mx-auto py-10 space-y-8">
    
          <div className="flex justify-start">
            <img src={logo} alt="Bestowal Systems" className="lg:h-[112px] h-12" />
          </div>
          
          
          <div className="grid grid-cols-1 md:grid-cols-8 gap-[60px]">
     
            <div className="md:col-span-2">
              <h3 className="flex items-center gap-2 lg:text-[20px] text-[#fff] sm:text-[16px]">
                <span className="text-lg">📍</span> Office Address
              </h3>
              <p className="mt-2 sm:text-[14px] lg:text-[18px] text-[#fff]">
                Bestowal Systems and Services Pvt. Ltd., 2nd Floor,
                Wadhwani Plaza, Near Ambedkar Chowk, Pimpri, Pune, Maharashtra,
                India 411018.
              </p>
              <p className="sm:mt-2 font-semibold text-lg lg:mt-[30px] lg:text-[20px]">+91 94055 30011</p>
            </div>

            <div className="space-y-2 md:col-span-2">
              <NavLink
                to="/supply-chain-management-solution"
                className="lg:text-[18px] hover:text-[#f26836] transition-colors"
              >
                SAP IBP Solutions
              </NavLink>
              <br />
              <NavLink
                to="/digital-core-transformation"
                className="lg:text-[18px] hover:text-[#f26836] transition-colors"
              >
                SAP S/4 HANA Solutions
              </NavLink>
              <br />
              <NavLink
                to="/industry"
                className="lg:text-[18px] hover:text-[#f26836] transition-colors"
              >
                Industry 4.0/5.0 Solutions
              </NavLink>
              <br />
              <NavLink
                to="/cloud"
                className="lg:text-[18px] hover:text-[#f26836] transition-colors"
              >
                Cloud Transformation Services
              </NavLink>
              <br />
              <NavLink
                to="/data-cloud-transformation"
                className="lg:text-[18px] hover:text-[#f26836] transition-colors"
              >
                Data Engineering
              </NavLink>
              <br />
            </div>

            <div className="space-y-2 w-fit">
              <NavLink
                to="/careers"
                className="lg:text-[18px] hover:text-[#f26836] transition-colors"
              >
                Careers
              </NavLink>
              <br />
              <NavLink
                to="/about"
                className="lg:text-[18px] hover:text-[#f26836] transition-colors"
              >
                About Us
              </NavLink>
              <br />
              <NavLink
                to="/contact-us"
                className="lg:text-[18px] hover:text-[#f26836] transition-colors"
              >
                Contact Us
              </NavLink>
              <br />
              <NavLink
                to="/blogs"
                className="lg:text-[18px] hover:text-[#f26836] transition-colors"
              >
                Blogs
              </NavLink>
            </div>

            <div className="space-y-2 md:col-span-2">
              <p className="lg:text-[18px] flex">
                HR:{" "}
                <a
                  href="mailto:hr@bestowalsystems.com"
                  className="text-gray-200 hover:text-[#f26836] transition-colors"
                >
                  hr@bestowalsystems.com
                </a>
              </p>
              <p className="lg:text-[18px] flex">
                Careers:{" "}
                <a
                  href="mailto:careers@bestowalsystems.com"
                  className="text-gray-200 hover:text-[#f26836] transition-colors"
                >
                  careers@bestowalsystems.com
                </a>
              </p>
              <p className="lg:text-[18px] flex">
                Business:{" "}
                <a
                  href="mailto:contact@bestowalsystems.com"
                  className="text-gray-200 hover:text-[#f26836] transition-colors"
                >
                  contact@bestowalsystems.com
                </a>
              </p>
            </div>

            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/company/bestowal-systems-and-services-private-limited/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#f26836] transition-colors duration-200"
              >
                <FaLinkedin size={20} />
              </a>
              <a
                href="https://www.facebook.com/bestowalsystems"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#f26836] transition-colors duration-200"
              >
                <FaFacebook size={20} />
              </a>
              <a
                href="https://www.instagram.com/bestowalsystems?igsh=MWY1ODV5Mmc4am02aA=="
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#f26836] transition-colors duration-200"
              >
                <FaInstagram size={20} />
              </a>

              <a
                href="https://youtube.com/@bestowalsystems?si=JwmKOLGIGSFmTbk5"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#f26836] transition-colors duration-200"
              >
                <FaYoutube size={20} />
              </a>

              <a
                href="https://x.com/bestowalsystems?t=tUhwfo5zEXhU5SON5Ice2g&s=09"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#f26836] transition-colors duration-200"
              >
                <FaTwitter size={20} />
              </a>


            </div>
          </div>
        </div>

      
        <div className="border-t border-gray-400/40">
          <p className="text-center text-sm sm:py-4 text-gray-300 lg:text-[18px] lg:py-[25px]">
            Copyright © 2025 Bestowal Systems & Services.{" "}
            <a
              href="https://www.bestowalsystems.com"
              className="underline hover:text-[#f26836] transition-colors"
            >
              www.bestowalsystems.com
            </a>{" "}
            | All Rights Reserved
          </p>
        </div>
      </footer> */}
      <footer className="bg-[#123359] text-white">
        {/* max-w tuned so the section gaps under the desktop 0.8 zoom match the
            design frame (content spans ~87% of a 1920 frame). */}
        <div className="w-[94%] max-w-[1630px] mx-auto py-[40px] sm:py-10 lg:pt-[44px] lg:pb-0">

          {/* 5-section layout (per the design frame): logo+about | Quick Links |
              Contact us | Emails | Follow us. Stacks on mobile, 2-up on small
              screens, 3-up on lg, full row on xl. Staggered fade-up on scroll. */}
          <motion.div
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-[minmax(0,400px)_max-content_minmax(0,300px)_max-content_max-content] gap-10 xl:gap-x-[48px] xl:gap-y-10 xl:justify-between"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={footerStagger}
          >

            {/* Col 1: Logo (links home) + tagline. Width capped so the tagline
                wraps on the same five lines as the design frame. */}
            <motion.div variants={footerColItem}>
              <NavLink to="/" onClick={scrollToTop} aria-label="Bestowal Systems — Home" className="inline-block">
                <img src={logo} alt="Bestowal Systems" className="lg:h-[60px] h-12" />
              </NavLink>
              <p className="mt-4 lg:mt-[30px] text-gray-200 text-[14px] lg:text-[16px] leading-relaxed text-left xl:max-w-[400px]">
                Bestowal Systems and Services Pvt. Ltd. delivers smart, scalable, and
                future-ready solutions in SAP Transformation, Industry 4.0/5.0, Custom
                Web and Mobile Applications, AI/ML Solutions, and Cloud Solutions.
              </p>
            </motion.div>

            {/* Col 2: Quick Links — mirrors the navbar's top-level tabs */}
            <motion.div variants={footerColItem}>
              <h3 className="text-[18px] lg:text-[20px] font-semibold mb-[8px]">Quick Links</h3>
              <ul className="space-y-1 list-none p-0 m-0 text-left">
                {QUICK_LINKS.map((l) => (
                  <li key={l.path} className="text-[15px] lg:text-[16px]">
                    <NavLink to={l.path} className="inline-block text-left leading-snug text-gray-100 hover:text-[#f26836] no-underline">
                      {l.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Col 3: Contact us — width capped so the address wraps on the
                same four lines as the design frame */}
            <motion.div variants={footerColItem} className="xl:max-w-[300px]">
              <h3 className="text-[18px] lg:text-[20px] font-semibold mb-[8px]">Contact us</h3>
              <p className="text-[15px] lg:text-[16px] leading-relaxed text-left">
                Bestowal Systems and Services Pvt. Ltd., 2nd Floor, Wadhwani Plaza,
                Near Ambedkar Chowk, Pimpri, Pune, Maharashtra, India 411018.
              </p>
              <p className="mt-3 text-[15px] lg:text-[16px]">+91 94055 30011</p>
            </motion.div>

            {/* Col 4: Emails */}
            <motion.div variants={footerColItem}>
              <h3 className="text-[18px] lg:text-[20px] font-semibold mb-[8px]">Emails</h3>
              <div className="space-y-[10px]">
                <p className="text-[15px] lg:text-[16px]">HR: <a href="mailto:hr@bestowalsystems.com" className="inline-block text-left leading-snug text-gray-100 hover:text-[#f26836] no-underline">hr@bestowalsystems.com</a></p>
                <p className="text-[15px] lg:text-[16px]">Careers: <a href="mailto:careers@bestowalsystems.com" className="inline-block text-left leading-snug text-gray-100 hover:text-[#f26836] no-underline">careers@bestowalsystems.com</a></p>
                <p className="text-[15px] lg:text-[16px]">Business: <a href="mailto:contact@bestowalsystems.com" className="inline-block text-left leading-snug text-gray-100 hover:text-[#f26836] no-underline">contact@bestowalsystems.com</a></p>
              </div>
            </motion.div>

            {/* Col 5: Follow us — social icons kept as-is */}
            <motion.div variants={footerColItem}>
              <h3 className="text-[18px] lg:text-[20px] font-semibold mb-[8px]">Follow us</h3>
              <div className="flex items-center gap-[15px]">
                <a href="https://www.linkedin.com/company/bestowal-systems-and-services-private-limited/" target="_blank" rel="noopener noreferrer" aria-label="Bestowal Systems on LinkedIn" className="text-white hover:text-[#f26836] transition-colors"><FaLinkedin size={22} /></a>
                <a href="https://www.facebook.com/bestowalsystems" target="_blank" rel="noopener noreferrer" aria-label="Bestowal Systems on Facebook" className="text-white hover:text-[#f26836] transition-colors"><FaFacebook size={22} /></a>
                <a href="https://www.instagram.com/bestowalsystems" target="_blank" rel="noopener noreferrer" aria-label="Bestowal Systems on Instagram" className="text-white hover:text-[#f26836] transition-colors"><FaInstagram size={22} /></a>
                <a href="https://youtube.com/@bestowalsystems" target="_blank" rel="noopener noreferrer" aria-label="Bestowal Systems on YouTube" className="text-white hover:text-[#f26836] transition-colors"><FaYoutube size={22} /></a>
                <a href="https://x.com/bestowalsystems" target="_blank" rel="noopener noreferrer" aria-label="Bestowal Systems on X (Twitter)" className="text-white hover:text-[#f26836] transition-colors"><FaTwitter size={22} /></a>
              </div>
            </motion.div>

          </motion.div>

          {/* Legal links — CMS-driven: every active policy (Admin → Legal
              Pages) renders here automatically. The three core pages keep
              their clean URLs; any new page uses the generic /policy/:slug. */}
          <motion.div
            className="mt-8 pb-4 lg:pb-[20px] flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[13px] lg:text-[16px]"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, ease: "easeOut" }}
          >
            {legalLinks.map((link, i) => {
              const corePaths = ["privacy-policy", "cookie-policy", "terms-of-use"];
              const to = corePaths.includes(link.slug)
                ? `/${link.slug}`
                : `/policy/${link.slug}`;
              return (
                <React.Fragment key={link.slug}>
                  {i > 0 && <span className="text-gray-500">|</span>}
                  <NavLink to={to} className="text-gray-300 hover:text-[#f26836] no-underline">
                    {link.title}
                  </NavLink>
                </React.Fragment>
              );
            })}
            {/* Reopens the cookie banner so consent can be changed or withdrawn */}
            <span className="text-gray-500">|</span>
            <button
              type="button"
              onClick={openCookiePreferences}
              className="bg-transparent border-0 p-0 text-gray-300 hover:text-[#f26836] cursor-pointer"
              style={{ font: "inherit" }}
            >
              Cookie settings
            </button>
          </motion.div>
        </div>

        {/* Bottom Line */}
        <motion.div
          className="border-t border-gray-400/40"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <div className="py-[18px] lg:py-[20px]">
            <p className="text-center text-[13px] text-gray-300 lg:text-[18px]">
              Copyright © {new Date().getFullYear()} Bestowal Systems & Services.{" "}
              <NavLink to="/" onClick={scrollToTop} className="text-gray-300 hover:text-[#f26836] no-underline">
                bestowalsystems.com
              </NavLink>{" "}
              | All Rights Reserved
            </p>
          </div>
        </motion.div>
      </footer>



      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 lg:bottom-[50px] right-6 bg-[#f26836] hover:bg-[#d55a2e] text-white p-3 rounded-full shadow-lg transition-all duration-300 z-50 hover:scale-110"
          aria-label="Scroll to top"
        >
          <FaChevronUp size={20} />
        </button>
      )}
    </>
  );
};

export default Footer;